export default "__VITE_ASSET__d98f3039__"